import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Badge, Col, Row } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import ActionsBar from '../../../components/ActionsBar';
import Button from '../../../components/CustomButton/CustomButton';
import OperatorsName from '../../../components/OperatorsName/OperatorsName';
import * as K from '../redux/SalesConstants';

class lodgingSale extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openConfirm: false,
      indexToDelete: 0,
    };
  }

  handleEdit = (index) => {
    var newSale = immutable.set(this.props.Sales, ['indexToEdit'], index);

    newSale = immutable.set(
      newSale,
      ['dataToEdit', 'lodging'],
      this.props.Sales.lodgings[index]
    );

    this.props.dispatch({
      type: K.SETSTATE,
      payload: newSale,
    });

    this.props.dispatch({
      type: K.OPEN_MODAL_ADD,
      payload: 'lodging',
    });
  };

  handleDelete(confirm = false, index) {
    if (confirm) {
      var newArray = immutable.del(this.props.Sales, [
        'lodgings',
        this.state.indexToDelete,
      ]);
      this.props.dispatch({
        type: K.SETSTATE,
        payload: newArray,
      });
      this.setState({ openConfirm: false });
    } else {
      this.setState({ openConfirm: true, indexToDelete: index });
    }
  }

  handleAdd = () => {
    this.props.dispatch({
      type: K.OPEN_MODAL_ADD,
      payload: 'lodging',
    });
  };

  render() {
    let { Sales } = this.props;
    let { openConfirm } = this.state;
    return (
      <div style={{ textAlign: 'justify' }}>
        <Row>
          <Col md={12}>
            {Sales.lodgings.map((lodging, index) => {
              return (
                <div key={index} style={{ marginBottom: '30px' }}>
                  {openConfirm && (
                    <SweetAlert
                      warning
                      style={{ display: 'block', marginTop: '-100px' }}
                      title="¿Estás Seguro?"
                      onConfirm={() => this.handleDelete(true)}
                      onCancel={() => this.setState({ openConfirm: false })}
                      confirmBtnBsStyle="info"
                      cancelBtnBsStyle="danger"
                      confirmBtnText="Si, borrar!"
                      cancelBtnText="Cancelar"
                      showCancel
                    >
                      No podrás revertir está opción!
                    </SweetAlert>
                  )}
                  <ActionsBar
                    title={lodging.hotel.name}
                    onEdit={() => this.handleEdit(index)}
                    onDelete={() => this.handleDelete(false, index)}
                  />
                  <br />

                  {lodging.rooms.map((room, index) => (
                    <div key={index}>
                      <Row>
                        <Col md={1} style={{ textAlign: 'right' }}>
                          <span
                            className="glyphicon glyphicon glyphicon glyphicon-menu-right"
                            aria-hidden="true"
                          />
                        </Col>
                        <Col md={11}>
                          <div className="form-group">
                            <label
                              style={{
                                fontWeight: 'bold',
                              }}
                              htmlFor="client"
                            >
                              HABITACION
                            </label>
                            <br />
                            <span>{room.description}</span>
                          </div>
                        </Col>
                      </Row>
                      {room.options.map((option, index) => (
                        <Row key={index}>
                          <Col
                            md={2}
                            style={{
                              textAlign: 'right',
                              alignItems: 'center',
                            }}
                          />
                          <Col md={1}>
                            <label
                              className="checkbox-inline"
                              style={{
                                marginTop: '6px',
                                padding: 0,
                              }}
                            ></label>
                          </Col>
                          <Col md={2}>
                            <div className="form-group">
                              <label
                                style={{
                                  fontWeight: 'bold',
                                }}
                                htmlFor="client"
                              >
                                COSTO DE COMPRA
                              </label>
                              <br />
                              <Badge
                                style={{
                                  backgroundColor: '#5FB404',
                                }}
                              >
                                {'   $ '}
                                {option.purchaseCost}
                              </Badge>
                            </div>
                          </Col>
                          <Col md={2}>
                            <div className="form-group">
                              <label
                                style={{
                                  fontWeight: 'bold',
                                }}
                                htmlFor="client"
                              >
                                PRECIO DE VENTA
                              </label>
                              <br />
                              <Badge
                                style={{
                                  backgroundColor: '#0489B1',
                                }}
                              >
                                {'   $ '}
                                {option.saleCost}
                              </Badge>
                            </div>
                          </Col>
                          <Col md={4}>
                            <div className="form-group">
                              <label
                                style={{
                                  fontWeight: 'bold',
                                }}
                                htmlFor="client"
                              >
                                DESCRIPCIÓN
                              </label>
                              <br />
                              <span>{option.description}</span>
                            </div>
                          </Col>
                        </Row>
                      ))}
                    </div>
                  ))}
                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          OPERADOR
                        </label>
                        <br />
                        <OperatorsName id={lodging.operator} />
                      </div>
                    </Col>
                  </Row>
                  <hr />
                </div>
              );
            })}
          </Col>
        </Row>
        <Button bsStyle="primary" onClick={this.handleAdd}>
          Agregar Hospedaje
        </Button>
      </div>
    );
  }
}

export default connect((state) => ({ Sales: state.Sales }))(lodgingSale);



// WEBPACK FOOTER //
// ./src/views/Sales/cardsSale/lodgingSale.js